import {
  HTTP_GETSPECIAL_FETCHING,
  HTTP_GETSPECIAL_SUCCESS,
  HTTP_GETSPECIAL_FAILED,
  server,
  OK,
  YES,
  HTTP_RESET_SPECIAL,
} from "././../../Constants";
import { httpClient } from "././../../utils/HttpClient";

export const setStateSpecialToFetching = () => ({
  type: HTTP_GETSPECIAL_FETCHING,
});

export const setStateSpecialToSuccess = (payload) => ({
  type: HTTP_GETSPECIAL_SUCCESS,
  payload,
});

export const setStateSpecialToFailed = (payload) => ({
  type: HTTP_GETSPECIAL_FAILED,
});

export const getSpecialAll = (
  ow_companyid,
  ow_brandid,
  ow_departmentid,
  yearid,
  countryid,
  companyid,
  brandid,
  departmentid
) => {
  return async (dispatch) => {
    dispatch(setStateSpecialToFetching());
    try {
      const result = await httpClient.get(
        `${server.GETSPECIAL_URL}/${ow_companyid}/${ow_brandid}/${ow_departmentid}
                                /${yearid}/${countryid}/${companyid}
                                /${brandid}/${departmentid}`
      );

      dispatch(setStateSpecialToSuccess(result.data));

      return Promise.resolve(result.data.length);
    } catch (error) {
      dispatch(setStateSpecialToFailed());
      return Promise.reject(error.message);
    }
  };
};

export const clearSpecialAll = () => {
  return (dispatch) => {
    dispatch({ type: HTTP_RESET_SPECIAL });
  };
};
